import { render, staticRenderFns } from "./TransactionsPPE.vue?vue&type=template&id=7dbdfb8a&scoped=true&"
import script from "./TransactionsPPE.vue?vue&type=script&lang=js&"
export * from "./TransactionsPPE.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsPPE.vue?vue&type=style&index=0&id=7dbdfb8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbdfb8a",
  null
  
)

export default component.exports